export default __webpack_public_path__ + "static/media/length.8fbdf424.svg";